export class PhoneProjectGroupEntity {
  public code: string;
  public name: string;
  public description: string;
  public isForLeasedEmployees = false;
  public isForCustomers = false;
  public questionnaireTemplate: any = null;
  public phoneProjectFilesDataUrl: any = null;
}
